<template>
    <div>
        <querytitle>
            <template slot="queryleft">
                <div>材料状态：</div>
                <div>
                    <el-select v-model="new_state" size="mini" style="width:90px;">
                        <el-option v-for="(item) in new_states" :key="item.FID" :label="item.FVALUE" :value="item.FID">
                        </el-option>
                    </el-select>
                </div>
                <div>材料类别：</div>
                <div>
                    <selecttreeview size="mini" :list="rules" @change="rulechange" :width="'120px'" :multiple="false" :clearable="true" :checkStrictly="false"  v-model="rule"></selecttreeview>
                    <!-- <selecttree :change="rulechange" v-model="rule" :data="rules" style="width:240px;"></selecttree> -->
                </div>
                <div>日期：</div>
                <div>
                    <el-date-picker v-model="BDATE" type="date" placeholder="选择开始日期" size="mini" style="width:130px;">
                    </el-date-picker>
                </div>
                <div>至</div>
                <div>
                    <el-date-picker v-model="EDATE" type="date" placeholder="选择结束日期" size="mini" style="width:130px;">
                    </el-date-picker>
                </div>
                <div>模糊查找:</div>
                <div><el-input size="mini" v-model="querykey"></el-input></div>
                <div>
                    <el-button type="primary" size="mini" @click="getlist()">查询</el-button>
                </div>
            </template>
            <template slot="queryright">
                <el-button type="danger" size="mini" @click="add()">新增材料</el-button>
            </template>
        </querytitle>
        <el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini">
            <el-table-column prop="new_type" label="材料类别" width="100"></el-table-column>
            <el-table-column prop="new_title" label="新闻标题"></el-table-column>
            <el-table-column prop="new_subtitle" label="摘要"></el-table-column>
            <el-table-column prop="new_date" label="新闻日期" width="100"></el-table-column>
            <el-table-column prop="edit_date" label="编辑日期" width="100"></el-table-column>
            <el-table-column prop="new_author" label="作者" width="100"></el-table-column>
            <el-table-column prop="new_state" label="状态" width="80" align="center"></el-table-column>
            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.new_state=='草稿' || scope.row.new_state=='不通过' ">
                        <el-link @click="edit(scope)" icon="el-icon-check" type="primary" size="mini">编辑</el-link>
                        <el-link type="danger" icon="el-icon-close" size="mini" @click="del(scope)">删除</el-link>
                        <el-link :href="'/api/newsshow?new_id='+scope.row.new_id" target="_blank" icon="el-icon-view"
                            type="success" size="mini">预览</el-link>
                    </div>
                    <div v-else>
                        <el-link :href="'/api/newsshow?new_id='+scope.row.new_id" target="_blank" icon="el-icon-view"
                            type="success" size="mini">材料查看预览</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 200]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="rt">
        </el-pagination>
        <el-dialog title="材料编辑" :visible="dialogFormVisible" :show-close="false" width="90%" top="10vh">
            <el-descriptions :column="3" border :labelStyle="{width:'120px'}">
                <el-descriptions-item :span="3">
                    <template slot="label">材料类别</template>
                    <selecttreeview :list="rules" @change="rulechange" :multiple="false" :clearable="true" :checkStrictly="false"  v-model="itemedit.new_type" @input="inputmethod()"></selecttreeview>
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">标题</template>
                    <el-input v-model="itemedit.new_title" @input="inputmethod()"></el-input>
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">摘要</template>
                    <el-input v-model="itemedit.new_subtitle" @input="inputmethod()"></el-input>
                </el-descriptions-item>
                <el-descriptions-item :span="1">
                    <template slot="label">新闻日期</template>
                    <el-date-picker v-model="itemedit.new_date" type="date" placeholder="选择开始日期" style="width:150px;" @input="inputmethod()">
                    </el-date-picker>
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                    <template slot="label">备注</template>
                    <div style="font-size:12px;font-weight: bold;">{{EVA.EVA_OTHER}}</div>
                </el-descriptions-item>
            </el-descriptions>
            <el-tabs v-model="activeName" style="margin: 0 10px 0 10px;">
                <el-tab-pane label="证明材料" name="证明材料">
                    <uploadfile ref="zms" :objid="itemedit.new_id" :flag="'edit'" :sqladd="true"></uploadfile>
                </el-tab-pane>
                <el-tab-pane label="正文内容" name="正文内容">
                    <el-input v-model="itemedit.new_content" style="font-size:13px;" type="textarea" :rows="15" :maxlength="SYS.len.contentlen" @input="inputmethod()">
                    </el-input>
                    <div style="color:#c0c0c0;font-size: 10px;float:right;">
                        {{itemedit.new_content?itemedit.new_content.length:0}}/{{SYS.len.contentlen}}
                    </div>
                </el-tab-pane>
                
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="post()">保存草稿</el-button>
                <el-button type="danger" @click="summit()">提交申请</el-button>
            </div>
        </el-dialog>
        <el-dialog title="提交申请" :visible="dialogFormVisible1" :show-close="false" width="60%" v-dialogDrag>
            <el-descriptions :column="3" border :labelStyle="{width:'120px'}">
                <el-descriptions-item :span="3">
                    <template slot="label">本单位申请意见</template>
                    <el-input size="mini" type="textarea" v-model="opinion" :row="8" :maxlength="SYS.len.chkmsglen">
                    </el-input>
                    <div style="color:#c0c0c0;font-size: 10px;float:right;">
                        {{opinion?opinion.length:0}}/{{SYS.len.chkmsglen}}
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1=false">取 消</el-button>
                <el-button type="primary" @click="summitdata()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import querytitle from '@/components/querytitle'
import uploadfile from '@/components/uploadfile'
import selecttreeview from '@/components/selecttreeview'
export default {
    components: {
        querytitle, uploadfile,selecttreeview
    },
    data() {
        return {
            hh: 500,
            loading: false,
            addflag: false,
            itemlist: [],
            itemindex: 0,
            itemedit: {},
            new_type:'',
            dialogFormVisible: false,
            rt: 0,
            currentPage: 1,
            pagesize: 20,
            pars: { objname: 'new_news' },
            querykey: "",
            new_state: '草稿',
            new_states: [],
            rules:[],
            evatype:{},
            rule:'',
            yys: [],
            yy: '2022',
            BDATE:'',
            EDATE:'',
            dialogFormVisible1: false,
            activeName:'证明材料',
            opinion:'',
            EVA:'',
            flag:false,
            //nowdate:'',
        };
    },
    created() {
        let that = this
        //that.nowdate = that.FormatDate(new Date())
        this.hh = document.documentElement.clientHeight - 220;
        this.GetYears(function (res) {
            that.yys = res.data
            that.yy = res.yy
        });
        that.GETENUM('new_news', 'new_state', true, function (res) {
            that.new_states = res
        })
        that.GetData('Flow/GetEvaRules',{},function(res){
            that.evatype = res.data.et
            that.rules = res.data.data;
            that.flag = res.data.flag;
        },function(err){
            that.$alert(err, { title: "错误", type: 'error' });
        })

        that.BDATE = that.yy+'-01-01';
        that.EDATE = that.FormatDate(new Date());
        this.getlist();
    },
    methods: {
        rulechange(e){
            this.EVA = e
        },
        add() {
            if(!this.flag){
                this.$alert('当前贵单位的创建申请流程还未通过，无法新增', {title: "错误", type:'error'});
                return;
            }
            if(this.CU.cu.ispay!='已付款'){
                this.$alert('您本年还未支付平台使用费，请联系平台客服完成付款流程后再正式使用！', {title: "错误", type:'error'});
                this.$router.replace("/main/paypage");
                return
            }
            if(this.nowdate()> this.EVA.EVA_ENDDATE){
                this.$alert('当前已过截止日期，无法再新增', {title: "错误", type:'error'});
                return;
            }
            this.activeName='正文内容'
            this.addflag = true;
            this.itemedit.new_id = this.GUID();
            this.itemedit.new_title="";
            this.itemedit.new_subtitle = "";
            this.itemedit.new_content=""
            this.itemedit.new_unit = this.CU.cu.orgid
            this.itemedit.new_yy = this.CU.cu.yy;
            // this.itemedit.new_type = '';
            // this.new_type = '';
            this.itemedit.new_state='草稿';
            this.itemedit.new_style='材料';
            this.itemedit.new_date = this.FormatDate(new Date())
            this.itemedit.new_author = this.CU.cu.uname
            this.itemedit.new_isdf='否'
            this.dialogFormVisible = true;

        },
        edit(par) {
            this.activeName='正文内容'
            this.addflag = false;
            this.itemindex = par.$index;
            this.itemedit = Object.assign({}, par.row);
            
            // this.new_type = this.itemedit.new_type
            this.dialogFormVisible = true;

        },
        del: function (par) {
            let that = this;
            that.$confirm("确定要删除当前行吗？", "询问", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                var pars = { objname: "new_news", model: par.row };
                that.PostData("Common/DEL", pars, function (res) {
                    if (res.data.error_code != 0) {
                        that.$alert(res.data.message, { title: "错误" });
                        return;
                    }
                    that.itemlist.splice(par.$index, 1);
                }, function (err) {
                    that.$alert(err, { title: "错误", type: 'error' });
                }
                );
            })
                .catch(() => { });
        },
        post(){
            let that = this
            this.itemedit.new_state='草稿'
            that.postdata(function(){
                that.dialogFormVisible = false;
                that.$refs.zms.enddrag();
            })
        },
        postdata(callback) {
            let that = this;
            if (!that.itemedit.new_title) {
                that.$alert("标题不能为空", { title: "提示" }); return;
            }
            if(!this.itemedit.new_type){
                that.$alert("请选择材料类别", { title: "提示" }); return;
            }
            if(this.EVA.EVA_LEVEL!=2){
                that.$alert("请选择正确的材料类别", { title: "提示" }); return;
            }
            if(this.nowdate()> this.EVA.EVA_ENDDATE){
                that.$alert('当前已过截止日期，无法再新增', {title: "错误", type:'error'});
                return;
            }
            //that.itemedit.new_unit = that.CU.cu.orgid
            // that.itemedit.new_type = that.new_type;
            that.itemedit.new_date = that.FormatDate(that.itemedit.new_date)
            that.itemedit.edit_date = that.FormatDate(new Date())
            let pars = { objname: "new_news", model: Object.assign({}, that.itemedit) };
            if (that.addflag) {
                that.PostData("Common/ADD", pars, function (res) {
                    if (res.data.error_code != 0) {
                        that.$alert(res.data.message, { title: "错误" }); return;
                    }
                    that.itemlist.push(pars.model);
                    that.addflag = false
                    callback()
                    //that.dialogFormVisible = false;
                }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
                );
            } else {
                that.PostData("Common/EDIT", pars, function (res) {
                    if (res.data.error_code != 0) {
                        that.$alert(res.data.message, { title: "错误" }); return;
                    }
                    that.$set(that.itemlist, that.itemindex, pars.model);
                    callback()
                    //that.dialogFormVisible = false;
                }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
                );
            }
        },
        getlist() {
            let that = this
            that.BDATE= that.FormatDate(that.BDATE)//+' 00:00:01'
            that.EDATE= that.FormatDate(that.EDATE)//+' 23:59:59'
            let wherestring = [{ field: 'new_unit', sym: '=', val: this.CU.cu.orgid, oper: 'and' },
                { field: 'new_date', sym: '>=', val: this.BDATE, oper: 'and' },
                { field: 'new_date', sym: '<=', val: this.EDATE, oper: 'and' },
            ]
            if(this.new_state)
                wherestring.push({ field: 'new_state', sym: '=', val: this.new_state, oper: 'and' })
            if(this.rule)
                wherestring.push({ field: 'new_type', sym: 'like', val: this.rule+'%', oper: 'and' })
            if (this.querykey) {
                wherestring.push({ field: 'new_title', sym: 'like', val: '%'+this.querykey+'%', oper: 'and' })
            }
            let pars = { objname: "new_news", wheres: wherestring, PageSize: that.pagesize, CurrentPage: that.currentPage}//, fields:['new_type','new_title','new_subtitle','new_date','edit_date','new_author','new_state','new_id']
            that.PostData("Common/GETLIST", pars, function (res) {
                that.itemlist = res.data.data;
                that.rt = res.data.rowTotal
            }, function (err) {
                that.$alert(err, { title: "错误" });
            }
            );
        },
        handleCurrentChange(e) {
            this.currentPage = e;
            this.getlist()
        },
        handleSizeChange(e) {
            this.pagesize = e;
            this.getlist()
        },
        uploaded() {
            this.getlist()
        },
        summit(){
            let that = this
            this.postdata(function(){
                if(that.checkform())
                    that.dialogFormVisible1 = true;
            });
        },
        checkform() {
            if (!this.itemedit.new_title) {
                this.$alert('请材料标题', { title: "错误" });
                return false;
            }
            if (!this.itemedit.new_date) {
                this.$alert('请输入新闻日期', { title: "错误" });
                return false;
            }
            if (!this.itemedit.new_type) {
                this.$alert('请输入材料类别', { title: "错误" });
                return false;
            }
            if (!this.itemedit.new_content && this.$refs.zms.imagelist.length<1) {
                this.$alert('请输入材料正文内容或者证明材料', { title: "错误" });
                return false;
            }
            return true;
        },
        summitdata() {
            let that = this
            let pars={
                f_id:'',
                f_type:'材料上报申请',
                obj_id:this.itemedit.new_id,
                f_check:'通过',
                f_opinion:that.opinion
            }
            that.PostData('Flow/FLOWGO', pars, function (res) {
                that.dialogFormVisible1 = false;
                that.dialogFormVisible = false;
                that.getlist();
            }, function (err) {
                that.$alert(err, { title: "错误" });
            })
        }
    }
};
</script>
